webpackJsonp([192811228858829],{

/***/ 431:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(179);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactIntl = __webpack_require__(26);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var About = function About(_ref) {
	  var founderImg = _ref.founderImg;
	  return _react2.default.createElement(
	    'div',
	    { id: 'about' },
	    _react2.default.createElement(
	      _reactIntl.FormattedMessage,
	      { id: 'about.title' },
	      function (title) {
	        return _react2.default.createElement(
	          _reactHelmet2.default,
	          null,
	          _react2.default.createElement(
	            'title',
	            null,
	            title
	          )
	        );
	      }
	    ),
	    _react2.default.createElement(
	      'div',
	      { id: 'main', className: 'alt' },
	      _react2.default.createElement(
	        'section',
	        { id: 'one' },
	        _react2.default.createElement(
	          'div',
	          { className: 'inner' },
	          _react2.default.createElement(
	            'header',
	            { className: 'major' },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'about.title', tagName: 'h1' })
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'image left' },
	            _react2.default.createElement('img', { src: founderImg, alt: 'Fran\xE7ois-Xavier Lemire' })
	          ),
	          _react2.default.createElement(_reactIntl.FormattedMessage, {
	            id: 'about.desc.1',
	            tagName: 'p',
	            values: { lla: _react2.default.createElement(
	                'a',
	                { href: 'http://www.lemireavocat.com' },
	                'Lemire Lemire avocats, s.e.n.c.'
	              ) }
	          }),
	          _react2.default.createElement(_reactIntl.FormattedMessage, {
	            id: 'about.desc.2',
	            tagName: 'p',
	            values: {
	              fintech: _react2.default.createElement(
	                'i',
	                null,
	                'FinTech'
	              ),
	              morgan: _react2.default.createElement(
	                'a',
	                { href: 'http://www.morganstanley.com/' },
	                'Morgan Stanley'
	              ),
	              skylanders: _react2.default.createElement(
	                'i',
	                null,
	                'Skylanders : SuperChargers'
	              ),
	              beenox: _react2.default.createElement(
	                'a',
	                { href: 'http://beenox.com/' },
	                'Activision'
	              ),
	              vungle: _react2.default.createElement(
	                'a',
	                { href: 'https://vungle.com/' },
	                'Vungle'
	              )
	            }
	          }),
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'about.desc.3', tagName: 'p' }),
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'about.desc.4', tagName: 'p' }),
	          _react2.default.createElement(
	            'ul',
	            { className: 'icons inline' },
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                { href: 'https://twitter.com/fxlemire', className: 'icon alt fa-twitter' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'label' },
	                  'Twitter'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                { href: 'https://www.linkedin.com/in/fxlemire/', className: 'icon alt fa-linkedin' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'label' },
	                  'LinkedIn'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                { href: 'https://github.com/fxlemire', className: 'icon alt fa-github' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'label' },
	                  'GitHub'
	                )
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	About.propTypes = {
	  founderImg: _propTypes2.default.string.isRequired
	};
	
	exports.default = About;
	module.exports = exports['default'];

/***/ }),

/***/ 442:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _About = __webpack_require__(431);
	
	var _About2 = _interopRequireDefault(_About);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AboutPage = function AboutPage(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(_About2.default, { founderImg: data.file.childImageSharp.responsiveResolution.src });
	};
	
	AboutPage.propTypes = {
	  data: _propTypes2.default.shape({
	    file: _propTypes2.default.shape({
	      childImageSharp: _propTypes2.default.shape({
	        responsiveResolution: _propTypes2.default.shape({
	          src: _propTypes2.default.string.isRequired
	        }).isRequired
	      }).isRequired
	    }).isRequired
	  }).isRequired
	};
	
	exports.default = AboutPage;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ }),

/***/ 588:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _about = __webpack_require__(442);
	
	var _about2 = _interopRequireDefault(_about);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _about2.default;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-apropos-fr-js-330631379435cd1f39cf.js